// extracted by mini-css-extract-plugin
export default {"Markdown":"markdown_Markdown__1sm_V typography_bodyFont__1UNdB"};